import { PATHWAY } from "@/constants/testIds";
import { PLATFORM_BOUNDARIES } from "@/lib/pathwayData";
import { SectionEyebrow } from "@/components/pathway/Journey";

export default function PlatformBoundaries() {
  return (
    <section
      id="boundaries"
      className="border-t hairline bg-[#0a0a0a]"
    >
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-28">
        <div className="grid gap-8 md:grid-cols-[1.2fr_1fr] md:items-end md:gap-16">
          <div>
            <SectionEyebrow>Platform boundaries</SectionEyebrow>
            <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-neutral-50 sm:text-4xl">
              KATLAS does not replace your platforms. It governs between them.
            </h2>
          </div>
          <p className="text-neutral-400">
            {PLATFORM_BOUNDARIES.reassurance}
          </p>
        </div>

        <div
          data-testid={PATHWAY.boundariesDiagram}
          className="mt-14 grid grid-cols-1 border-l hairline md:grid-cols-5"
        >
          {PLATFORM_BOUNDARIES.flow.map((n, i) => (
            <article
              key={n.slug}
              data-testid={PATHWAY.boundaryNode(n.slug)}
              className={`relative border-b border-r hairline p-6 md:border-b-0 md:p-8 ${
                n.katlas ? "bg-[#101010]" : ""
              }`}
            >
              <div
                className={`font-mono text-[10px] uppercase tracking-[0.28em] ${
                  n.katlas ? "text-amber-500" : "text-neutral-500"
                }`}
              >
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3
                className={`mt-4 font-serif text-xl leading-snug ${
                  n.katlas ? "text-amber-500" : "text-neutral-100"
                }`}
              >
                {n.label}
              </h3>
              <div className="mt-3 text-[12px] leading-relaxed text-neutral-400">
                {n.role}
              </div>
              {/* Connector arrow on right edge */}
              {i < PLATFORM_BOUNDARIES.flow.length - 1 && (
                <span className="pointer-events-none absolute right-[-7px] top-1/2 hidden h-3 w-3 -translate-y-1/2 rotate-45 border-r border-t border-amber-700 md:block" />
              )}
            </article>
          ))}
        </div>

        <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.24em] text-neutral-500">
          AI makes a recommendation · KATLAS governs · downstream platforms execute, record and continue.
        </div>
      </div>
    </section>
  );
}
